import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DatasetsListComponent } from './datasets-list/datasets-list.component';
import { DatasetsDetailComponent } from './datasets-detail/datasets-detail.component';

const routes: Routes = [
    {
        path: 'datasets',
        children: [
            { path: '', component: DatasetsListComponent }
        ]
    },
    {
        path: 'datasets/:id',
        children: [
            { path: '', component: DatasetsDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DatasetsRoutingModule { }
